import tCoinLogo from '../../images/t-coin-logo.svg';
import ExternalLink from '../ExternalLink';

import './TakeBackBagsListItem.scss';

const TakeBackBagsListItem = ({
  tbbItem: {
    label,
    ctaLabel,
    imgUrl,
    url,
    bgColor,
  } = {},
  trackerProps = {},
}) => (
  <ExternalLink
    className="TakeBackBagsListItem"
    href={url}
    {...trackerProps}
  >
    <div
      className="TakeBackBagsListItem__imgContainer"
      style={{
        backgroundImage: `url(${imgUrl || tCoinLogo})`,
        backgroundColor: bgColor,
      }}
    />
    <div className="TakeBackBagsListItem__details">
      <div
        className="TakeBackBagsListItem__details-label"
        title={label}
      >
        {label}
      </div>
      <div className="TakeBackBagsListItem__cta">
        {ctaLabel || 'BUY NOW'}
      </div>
    </div>
  </ExternalLink>
);

export default TakeBackBagsListItem;
